import { createFileRoute } from "@tanstack/react-router";
import { PortalFormsPage } from "@/features/portalforms/PortalFormsPage";

/** Portal forms (P109): the live forms shared with the client, each linking to its public form page. */
export const Route = createFileRoute("/portal/forms")({ component: PortalFormsPage });
